import React from 'react'
import { Link } from 'react-router-dom'
import { contactEmail, walkthrough } from '../../content/csp'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const WalkthroughCta = () => {
  return (
    <section className="csp-section csp-section--ink">
      <div className="container">
        <div className="csp-walkthrough">
          <div>
            <span className="csp-kicker">{walkthrough.kicker}</span>
            <h2 className="csp-title">{walkthrough.title}</h2>
            <p className="csp-lead">{walkthrough.text}</p>
          </div>
          <div className="csp-walkthrough-actions">
            <Link onClick={ClickHandler} className="theme-btn" to="/contact">
              <span className="text">{walkthrough.action}</span>
            </Link>
            <a className="csp-walkthrough-email" href={`mailto:${contactEmail}`}>
              {contactEmail}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WalkthroughCta
